<!------------ START TEMPLATE ------------>
<template>
  <div>
    <div slot="header">
      <h3>
        Histórico de Mensagens
        <br style="clear: both" />
      </h3>
    </div>
    <br class="break" />
    <div class="overflow-x-auto">
      <GenericTable
        :headers="tableHeaders"
        :items="filteredMessages"
        :buttons="tableButtons"
        :onDelete="onDelete"
      />
    </div>

    <br class="break" />
    <div class="row mt-5 text-right">
      <vs-button
        color="#FFBA00"
        class="mr-3 mb-2"
        @click="openDeletedMessagesModal"
      >
        Mensagens Excluídas
      </vs-button>
    </div>
    <GenericPromptModal
      ref="confirmModal"
      title="Excluir Mensagem"
      icon="icon-alert-triangle"
      message="Tem certeza de que deseja excluir esta Mensagem?"
      iconColor="#FF4757"
      @confirmed="onConfirmDelete"
      icon-pack="feather"
    />
    <ModalMensagemHistorico
      ref="deletedMessagesModal"
      :headers="tableHeaders"
      :items="deletedMessages"
      :buttons="tableButtons"
    />
    <ModalMensagemFilesPhotos
      ref="photosMessagesModal"
      :idPropostaNota="idPropostaNota"
    />
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import services from '../../services';
import GenericTable from '../../components/generic/GenericTable.vue';
import GenericPromptModal from '../../components/generic/GenericPromptModal.vue';
import ModalMensagemHistorico from '../modais/ModalMensagemHistorico.vue';
import ModalMensagemFilesPhotos from '../modais/ModalMensagemFilesPhotos.vue';

export default {
  name: 'ListHistoricoMensagensVistoria',
  props: {
    keyForm: Number,
  },
  watch: {
    keyForm: {
      handler() {
        this.getAllMessages();
      },
      immediate: true,
    },
  },
  data() {
    return {
      listMessages: [],
      loading: false,
      tableHeaders: [
        { key: 'assunto', label: 'Assunto' },
        { key: 'mensagem', label: 'Mensagem' },
        { key: 'createdAt', label: 'Data', isDate: true },
        { key: 'createdAt', label: 'Hora', isTime: true },
        { key: 'usuarios.nome', label: 'Usuário' },
        {
          key: 'usuarios.Usuarios_Perfil.nomePerfil',
          label: 'Perfil de Usuário',
        },
      ],
      tableButtons: [
        {
          iconPack: 'feather',
          icon: 'icon-more-horizontal',
          color: '#1F74FF',
          action: (item) => {
            this.openPhotosMessagesModal(item.idPropostaNota);
          },
        },
        {
          iconPack: 'feather',
          icon: 'icon-trash',
          color: '#FF4757',
          action: (item) => this.onDelete(item.idPropostaNota),
          disabled: this.loading,
        },
      ],
      idToDelete: null,
      idPropostaNota: null,
    };
  },
  methods: {
    onDelete(idPropostaNota) {
      this.$refs.confirmModal.showModal();
      this.idToDelete = idPropostaNota;
    },
    async onConfirmDelete(confirmed) {
      if (confirmed) {
        try {
          this.loading = true;
          const model = 'propostas-notas';
          const action = `PropostasNotas/${this.idToDelete}`;
          await services.delete(model, action, {});
          this.$vs.notify({
            position: 'top-center',
            text: 'Mensagem excluída com sucesso.',
            color: 'success',
          });
          this.getAllMessages();
        } catch {
          console.error('Erro ao excluir mensagens!');
        } finally {
          this.loading = false;
        }
      }
    },
    async getAllMessages() {
      const idProposta = this.$route.params.idCotacao;
      try {
        this.loading = true;
        const model = 'propostas-notas';
        const action = `GetPropostasNotas/${idProposta}`;
        const listPropostasNotasById = await services.getAll(model, {}, action);
        this.listMessages = listPropostasNotasById.data;
      } catch {
        console.error('Error ao buscar mensagens.');
      } finally {
        this.loading = false;
      }
    },
    openDeletedMessagesModal() {
      this.$refs.deletedMessagesModal.isModalActive = true;
    },
    openPhotosMessagesModal(idPropostaNota) {
      this.idPropostaNota = idPropostaNota;

      this.$refs.photosMessagesModal.isModalActive = true;
    },
    removeHtmlTags(input) {
      const regex = /<[^>]*>/g;
      return input.replace(regex, '');
    },
  },
  computed: {
    filteredMessages() {
      return this.listMessages
        .filter((message) => message.deletedAt === null)
        .map((message) => {
          message.mensagem = this.removeHtmlTags(message.mensagem);
          return message;
        });
    },
    deletedMessages() {
      return this.listMessages
        .filter((message) => message.deletedAt !== null)
        .map((message) => {
          message.mensagem = this.removeHtmlTags(message.mensagem);
          return message;
        });
    },
  },
  mounted() {
    this.getAllMessages();
  },
  components: {
    GenericTable,
    GenericPromptModal,
    ModalMensagemHistorico,
    ModalMensagemFilesPhotos,
  },
};
</script>

<style lang="scss">
.table-bordered {
  tr:nth-child(2n) {
    background-color: #ffffff !important;
  }

  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
